import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { AsyncTypeahead, Typeahead } from "react-bootstrap-typeahead";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Select from "react-validation/build/select";
import CheckButton from "react-validation/build/button";
import Swal from "sweetalert2";
import { token } from "../Actions/AuthAction";
import {
  candidateBasicDetailUpdate,
  candidatePreferredLocationUpdate,
  candidateProjectUpdate,
  candidateQualificationUpdate,
  candidateSkillUpdate,
  candidateTrainingUpdate,
} from "../Actions/CandidateAction";
import {
  GetCourses,
  GetSkill,
  selectDistrict,
  selectFilterCities,
  selectState,
} from "../Actions/CommonAction";

import { required, phonevalid, pincodevalid } from "../Common/CommonValidation";
import moment from "moment";

export const EditProfile = (props) => {
  const [data, setData] = useState(null);
  const showBody = () => {
    if (props.step == 1) {
      return PersonalDetails(props, setData);
    }
    if (props.step == 2) {
      return EducationDetails(props, setData);
    }
    if (props.step == 3) {
      return ProjectDetails(props, setData);
    }
    if (props.step == 4) {
      return CertificationAndTraining(props, setData);
    }
  };
  const onSubmit = () => {
    // if (props.step == 1) {
    // submitPersonalDetails(data);
    // }
    // if (props.step == 2) {
    //   submitEducationDetails(data);
    // }
    // if (props.step == 3) {
    //   submitProjectDetails(data);
    // }
    // if (props.step == 4) {
    //   submitCertificationAndTraining(data);
    // }
  };
  return (
    <>
      <Modal onHide={props.handleClose} show={true}>
        <Modal.Header>
          <Modal.Title>{props.heading}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{showBody()}</Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" className="btn btn-secondary-custom d-block ml-auto" onClick={props.handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={props.handleClose}>
            Save Changes
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};

const ProjectDetails = (props) => {
  const [data, setdata] = useState(props.data.candidateprojects);
  const form = useRef();
  const checkBtn = useRef();
  const onChange = (e, index) => {
    let dummydata = data;
    dummydata[index][e.target.name] = e.target.value;

    setdata([...dummydata]);
  };
  const add = (e) => {
    e.preventDefault();
    let dummydata = data;
    dummydata[dummydata.length] = {
      propjectname: "",
      projectdescription: "",
      startdate: "",
      enddate: "",
    };
    setdata([...dummydata]);
  };
  const sub = (value) => {
    setdata([...data.filter((_, idx) => idx !== value)]);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      props.setLoading(true);
      const jsonToPost = {
        loginusertoken: token(),
        projectsDetails: data,
      };

      candidateProjectUpdate(jsonToPost).then((res) => {
        if (res.status) {
          Swal.fire("Success", "Data has been saved", "success");
          props.handleClose();
          props.loadData();
        } else {
          Swal.fire("Error", res.error_mssage, "error");
        }
        props.setLoading(false);
      });
    }
  };
  return (
    <>
      <Form ref={form}>
        {data.map((item, index) => {
          return (
            <>
              {data.length > 1 && (
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-primary-custom"
                    onClick={(e) => {
                      e.preventDefault();
                      sub(index);
                    }}
                  >
                    Remove
                  </button>
                </div>
              )}{" "}
              <div className="form-group">
                <label>Project Name</label>
                <Input
                  validations={[required]}
                  className="form-control rounded-pill"
                  name="propjectname"
                  value={item["propjectname"]}
                  onChange={(e) => onChange(e, index)}
                />
                <label>Project Description</label>
                <Input
                  validations={[required]}
                  className="form-control rounded-pill"
                  name="projectdescription"
                  value={item["projectdescription"]}
                  onChange={(e) => onChange(e, index)}
                />
                <label>Start Date</label>
                <Input
                  validations={[required]}
                  className="form-control rounded-pill"
                  type="date"
                  name="startdate"
                  value={item["startdate"].split(" ")[0]}
                  onChange={(e) => onChange(e, index)}
                />
                <label>End Date</label>
                <Input
                  validations={[required]}
                  className="form-control rounded-pill"
                  type="date"
                  name="enddate"
                  valu={item["enddate"]}
                  value={item["enddate"].split(" ")[0]}
                  onChange={(e) => onChange(e, index)}
                />
              </div>
            </>
          );
        })}
        <div className="d-flex justify-content-end mb-2">
          <button className="btn btn-primary-custom" onClick={add}>
            Add
          </button>
        </div>
        <div className="d-flex justify-content-end">
          <button className="btn btn-primary-custom" onClick={onSubmit}>
            Submit
          </button>
          <Button
            variant="secondary"
            className="btn btn-secondary-custom ml-2"
            onClick={props.handleClose}
          >
            Close
          </Button>
        </div>
        <CheckButton style={{ display: "none" }} ref={checkBtn} />
      </Form>
    </>
  );
};

const CertificationAndTraining = (props) => {
  const [data, setdata] = useState(props.data.candidatetrainings);
  const form = useRef();
  const checkBtn = useRef();
  const onChange = (e, index) => {
    let dummydata = data;
    dummydata[index][e.target.name] = e.target.value;

    setdata([...dummydata]);
  };
  const add = (e) => {
    e.preventDefault();
    let dummydata = data;
    dummydata[dummydata.length] = {
      trainingrole: "",
      trainingdiscription: "",
      startdate: "",
      enddate: "",
    };
    setdata([...dummydata]);
  };
  const sub = (value) => {
    setdata([...data.filter((_, idx) => idx !== value)]);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    form.current.validateAll();
    console.log(checkBtn.current.context._errors);
    if (checkBtn.current.context._errors.length === 0) {
      props.setLoading(true);
      const jsonToPost = {
        loginusertoken: token(),
        trainingAndCertificationDetails: data,
      };

      candidateTrainingUpdate(jsonToPost).then((res) => {
        if (res.status) {
          Swal.fire("Success", "Data has been saved", "success");
          props.handleClose();
          props.loadData();
        } else {
          Swal.fire("Error", res.error_mssage, "error");
        }
        props.setLoading(false);
      });
    }
  };
  return (
    <>
      <Form ref={form}>
        {data.map((item, index) => {
          return (
            <>
              {data.length > 1 && (
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-primary-custom"
                    onClick={(e) => {
                      e.preventDefault();
                      sub(index);
                    }}
                  >
                    Remove
                  </button>
                </div>
              )}
              <div className="form-group">
                <label>Trainning Role</label>
                <Input
                  validations={[required]}
                  className="form-control rounded-pill"
                  name="trainingrole"
                  value={item["trainingrole"]}
                  onChange={(e) => onChange(e, index)}
                />
                <label>Trainning Description</label>
                <Input
                  validations={[required]}
                  className="form-control rounded-pill"
                  name="trainingdiscription"
                  value={item["trainingdiscription"]}
                  onChange={(e) => onChange(e, index)}
                />
                <label>Start Date</label>
                <Input
                  validations={[required]}
                  className="form-control rounded-pill"
                  type="date"
                  name="startdate"
                  value={item["startdate"].split(" ")[0]}
                  onChange={(e) => onChange(e, index)}
                />
                <label>End Date</label>
                <Input
                  validations={[required]}
                  className="form-control rounded-pill"
                  type="date"
                  name="enddate"
                  value={item["enddate"].split(" ")[0]}
                  onChange={(e) => onChange(e, index)}
                />
              </div>
            </>
          );
        })}
        <div className="d-flex justify-content-end mb-2">
          <button className="btn btn-primary-custom" onClick={add}>
            Add
          </button>
        </div>
        <div className="d-flex justify-content-end">
          <button className="btn btn-primary-custom" onClick={onSubmit}>
            Submit
          </button>
          <Button
            variant="secondary"
            className="btn btn-secondary-custom ml-2"
            onClick={props.handleClose}
          >
            Close
          </Button>
        </div>
        <CheckButton style={{ display: "none" }} ref={checkBtn} />
      </Form>
    </>
  );
};
const EducationDetails = (props) => {
  const [data, setdata] = useState(props.data.candidatequalificationmaps);
  const [courseOptions, setCourseOptions] = useState([]);
  const form = useRef();
  const checkBtn = useRef();
  useEffect(() => {
    GetCourses({ status: 1 }).then((res) => {
      setCourseOptions(res.data);
    });
  }, []);

  const onChange = (e, index, name = false) => {
    let dummydata = data;
    dummydata[index][e.target.name] = e.target.value;
    setdata([...dummydata]);
  };
  const add = (e) => {
    e.preventDefault();
    let dummydata = data;
    dummydata[dummydata.length] = {
      "board/University": "",
      "collage/school": "",
      "course/subject": "",
      percentage: "",
      qualificationtype: "",
      yearofpassing: "",
      course: [],
    };
    setdata([...dummydata]);
  };
  const sub = (value) => {
    setdata([...data.filter((_, idx) => idx !== value)]);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      props.setLoading(true);
      const jsonToPost = data.map((item) => {
        return {
          qualificationname: item.qualificationname,
          board: item["board/University"],
          subject: item["course/subject"],
          percentage: item.percentage,
          college: item["collage/school"],
          yearofpassing: item.yearofpassing,
        };
      });
      candidateQualificationUpdate({
        loginusertoken: token(),
        educationalDetails: jsonToPost,
      }).then((res) => {
        if (res.status) {
          Swal.fire("Success", "Data has been saved", "success");
          props.handleClose();
          props.loadData();
        } else {
          Swal.fire("Error", res.error_mssage, "error");
        }
        props.setLoading(false);
      });
    }
  };
  return (
    <>
      <Form ref={form}>
        {data.map((item, index) => {
          return (
            <>
              {data.length > 1 && (
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-primary-custom"
                    onClick={(e) => {
                      e.preventDefault();
                      sub(index);
                    }}
                  >
                    Remove
                  </button>
                </div>
              )}
              <div className="form-group">
                <label>Board/University</label>
                <Input
                  validations={[required]}
                  className="form-control rounded-pill"
                  name="board/University"
                  value={item["board/University"]}
                  onChange={(e) => onChange(e, index)}
                />
                <label>Collage/School</label>
                <Input
                  validations={[required]}
                  className="form-control rounded-pill"
                  name="collage/school"
                  value={item["collage/school"]}
                  onChange={(e) => onChange(e, index)}
                />
                <label>Course/Subject</label>

                <Select
                  validations={[required]}
                  className="form-control rounded-pill"
                  // value={item["course"].id}
                  onChange={(e) => (item["course/subject"] = e.target.value)}
                >
                  {console.log(courseOptions, "courseOptions")}
                  <option value="">Select Course</option>
                  {courseOptions &&
                    courseOptions.map((i, index2) => (
                      <option name={index} value={i.id}>
                        {i.name}
                      </option>
                    ))}
                </Select>
                {/* <Typeahead
                id="course"
                labelKey="name"
                onChange={(e) => onChange(e, index, "course")}
                options={courseOptions}
                placeholder="Choose Course..."
                selected={[item["course"]]}
              /> */}
                <label>Percentage</label>
                <Input
                  validations={[required]}
                  className="form-control rounded-pill"
                  name="percentage"
                  type="number"
                  value={item["percentage"]}
                  onChange={(e) => onChange(e, index)}
                />
                <label>Year Of Passing</label>
                <Input
                  validations={[required]}
                  className="form-control rounded-pill"
                  type="number"
                  name="yearofpassing"
                  value={item["yearofpassing"]}
                  onChange={(e) => onChange(e, index)}
                />
                <label>Qualification Name</label>
                <Input
                  validations={[required]}
                  className="form-control rounded-pill"
                  name="qualificationname"
                  value={item["qualificationname"]}
                  onChange={(e) => onChange(e, index)}
                />
              </div>
            </>
          );
        })}
        <div className="d-flex justify-content-end mb-2">
          <button className="btn btn-primary-custom" onClick={add}>
            Add
          </button>
        </div>
        <div className="d-flex justify-content-end">
          <button className="btn btn-primary-custom" onClick={onSubmit}>
            Submit
          </button>
          <Button
            variant="secondary"
            className="btn btn-secondary-custom ml-2"
            onClick={props.handleClose}
          >
            Close
          </Button>
        </div>
        <CheckButton style={{ display: "none" }} ref={checkBtn} />
      </Form>
    </>
  );
};

const PersonalDetails = (props) => {
  const form = useRef();
  const checkBtn = useRef();
  const [fathersname, setfathersname] = useState(props.data.fathersname);
  const [alternatenumber, setalternatenumber] = useState(
    props.data.alternatenumber
  );
  const [address, setaddress] = useState(props.data.address);
  const [gender, setgender] = useState(props.data.gender);

  const [pincode, setpincode] = useState(props.data.pincode);
  const [selectedState, setselectedState] = useState([props.data.state]);
  const [stateOption, setstateOption] = useState([]);
  const [selectedcity, setselectedcity] = useState([
    { id: props.data.city.district_id, name: props.data.city.name },
  ]);
  const dummySkilldate = props.data.candidateskills.map((item) => item.skills);
  const dummypreferedLocationdate = props.data.candidatepreferredlocations.map(
    (item) => item.preferredlocation0
  );

  const [cityOption, setcityOption] = useState([]);
  const [skill, setskill] = useState(dummySkilldate);
  const [skilloption, setskilloption] = useState([]);
  const [preferedLocation, setpreferedLocation] = useState(
    dummypreferedLocationdate
  );
  const [preferedLocationoption, setpreferedLocationoption] = useState([]);

  useEffect(() => {
    loadData();
  }, []);
  const loadData = () => {
    selectState({ status: 1 }).then((res) => {
      setstateOption(res.data);
    });
    GetSkill({ status: 1 }).then((res) => {
      setskilloption(res.data);
    });
    getCity(props.data.state.state_id);
  };
  const getCity = (stateId) => {
    selectDistrict({ state_id: stateId }).then((res) => {
      let data = res.data.map((item) => {
        return { id: item.district_id, name: item.name };
      });
      setcityOption(data);
    });
  };
  const getPreferedLocation = (param) => {
    selectFilterCities({ city: param }).then((res) => {
      setpreferedLocationoption(res.data);
    });
  };
  const onSubmit = (e) => {
    e.preventDefault();
    form.current.validateAll();
    console.log(checkBtn.current.context._errors);
    if (checkBtn.current.context._errors.length === 0) {
      props.setLoading(true);
      const jsonToPost = {
        loginusertoken: token(),
        cityid: selectedcity[0].id,
        stateid: selectedState[0].state_id,
        pincode: pincode,
        gender: gender,
        fathersname: fathersname,
        alternatenumber: alternatenumber,
        address: address,
      };
      const skilldata = skill.map((item) => {
        return { skillsid: item.skillcode };
      });
      const skillToPost = {
        loginusertoken: token(),
        skillsDetails: skilldata,
      };
      const preferedLocationdata = preferedLocation.map((item) => {
        return { preferredlocation: item.district_id };
      });
      const preferredLocationToPost = {
        loginusertoken: token(),
        preferredlocation: preferedLocationdata,
      };
      console.log(preferedLocation);
      candidateBasicDetailUpdate(jsonToPost).then((res) => {
        candidateSkillUpdate(skillToPost).then((res2) => {
          candidatePreferredLocationUpdate(preferredLocationToPost).then(
            (res3) => {
              if (res.status && res2.status && res3.status) {
                Swal.fire("Success", "Your Data has been updated", "success");
                props.handleClose();
                props.loadData();
              } else {
                Swal.fire(
                  "Success",
                  res.error_mssage
                    ? res.error_mssage
                    : res2.error_mssage
                      ? res2.error_mssage
                      : res3.error_mssage
                        ? res3.error_mssage
                        : "Something went wrong!!",
                  "success"
                );
              }
              props.setLoading(false);
            }
          );
        });
      });
    }
  };
  return (
    <>
      <Form ref={form}>
        <div className="form-group">
          <label>Father Name</label>
          <Input
            validations={[required]}
            className="form-control rounded-pill"
            value={fathersname}
            onChange={(e) => setfathersname(e.target.value)}
          ></Input>
        </div>
        <div className="form-group">
          <label>Alternate No.: </label>
          <Input
            validations={[required, phonevalid]}
            className="form-control rounded-pill"
            value={alternatenumber}
            onChange={(e) => setalternatenumber(e.target.value)}
          ></Input>
        </div>
        <div className="form-group">
          <label>Gender:</label>
          <select
            value={gender}
            onChange={(e) => setgender(e.target.value)}
            className="form-control rounded-pill"
          >
            <option value={1}>Male</option>
            <option value={2}>Female</option>
            <option value={3}>Others</option>
          </select>
        </div>
        <div className="form-group">
          <label>Address:</label>
          <Input
            validations={[required]}
            className="form-control rounded-pill"
            value={address}
            onChange={(e) => setaddress(e.target.value)}
          ></Input>
        </div>
        <div className="form-group">
          <label>State:</label>
          <Typeahead
            className="rounded-pill"
            id="state"
            labelKey="name"
            onChange={(e) => {
              setselectedState(e);
              setcityOption([]);
              if (e[0]) getCity(e[0].state_id);
              setselectedcity([]);
            }}
            options={stateOption}
            placeholder="Choose State..."
            selected={selectedState}
          />
        </div>
        <div className="form-group">
          <label>City:</label>
          <Typeahead
            className="rounded-pill"
            id="city"
            labelKey="name"
            onChange={setselectedcity}
            options={cityOption}
            placeholder="Choose State..."
            selected={selectedcity}
          />
        </div>
        <div className="form-group">
          <label>Pincode:</label>
          <Input
            validations={[required, pincodevalid]}
            className="form-control rounded-pill"
            value={pincode}
            onChange={(e) => setpincode(e.target.value)}
            type="number"
            min={100000}
            max={999999}
          ></Input>
        </div>
        <div className="form-group">
          <label>Prefered Location:</label>
          <AsyncTypeahead
            minLength={2}
            id="location"
            labelKey="name"
            multiple
            onSearch={(e) => {
              getPreferedLocation(e);
            }}
            onChange={setpreferedLocation}
            options={preferedLocationoption}
            placeholder="Choose several Prefered location..."
            selected={preferedLocation}
          />
          {/* <label>Skills:</label>
        <Input
         validations={[required]} value={props.data.a}></Input> */}
        </div>{" "}
        <div className="form-group">
          <label>Skills:</label>
          <Typeahead
            id="skills"
            labelKey="skillname"
            multiple
            onChange={setskill}
            options={skilloption}
            placeholder="Choose several Skills..."
            //   selected={props.data.candidatepreferredlocations}
            selected={skill}
          />

          {/* <label> Prefred Location:</label>
        <Input
         validations={[required]} value={props.data.candidatepreferredlocations}></Input> */}
        </div>
        <div className="d-flex justify-content-end">
          <button className="btn btn-primary-custom" onClick={onSubmit}>
            Submit
          </button>
          <Button
            variant="secondary"
            className="btn btn-secondary-custom ml-2"
            onClick={props.handleClose}
          >
            Close
          </Button>
        </div>
        <CheckButton style={{ display: "none" }} ref={checkBtn} />
      </Form>
    </>
  );
};
